var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStartsChallenge = function SvgStartsChallenge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 110,
    height: 165,
    fill: "none",
    viewBox: "0 0 110 165"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint0_linear_11236_65724)",
    d: "m9.956 118.23 22.054.102 14.433-16.676-.102 22.054 16.676 14.433-22.054-.102-14.433 16.676.102-22.054z",
    opacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint1_linear_11236_65724)",
    d: "m82.863 90.732 9.17 2.297 7.712-5.465-2.297 9.169 5.465 7.712-9.169-2.297-7.712 5.466 2.297-9.17z",
    opacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint2_linear_11236_65724)",
    d: "m39.302 23.271 10.062-7.044 1.202-12.225 7.044 10.063 12.225 1.201-10.062 7.045-1.202 12.224-7.045-10.062z",
    opacity: 0.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#paint3_linear_11236_65724)",
    d: "m32.376 71.912 4.211-.387 2.447-3.448.387 4.21 3.448 2.448-4.21.386-2.448 3.449-.386-4.211z",
    opacity: 0.4
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11236_65724",
    x1: 46.443,
    x2: 26.53,
    y1: 101.656,
    y2: 154.717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4B346"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F3F1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_11236_65724",
    x1: 99.745,
    x2: 86.032,
    y1: 87.564,
    y2: 107.614,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4B346"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F3F1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_11236_65724",
    x1: 50.566,
    x2: 58.571,
    y1: 4.002,
    y2: 34.535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4AF46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F381B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_11236_65724",
    x1: 39.034,
    x2: 36.211,
    y1: 68.077,
    y2: 78.57,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4B346"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F3F1B"
  })))));
};
export default SvgStartsChallenge;